import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DatePill, DatePillProps } from '../avatar-pill/date-pill';
import { SlotCount } from './slot-count';

interface Props extends DatePillProps {
  slotsCount?: number;
}

export const WeekdayColumnHeader = ({ slotsCount, ...props }: Props) => {
  return (
    <div css={containerStyle}>
      <DatePill {...props} />
      {slotsCount !== undefined && <SlotCount count={slotsCount} />}
    </div>
  );
};

const containerStyle = css({
  borderRight: `1px solid ${theme.colors.neutral10}`,
  '&:first-child': {
    borderLeft: `1px solid ${theme.colors.neutral10}`,
  },
  '> :first-child': {
    borderBottom: `1px solid ${theme.colors.neutral10}`,
    padding: theme.spacing(0.5),
  },
});
